import gaSC from '@common/utils/ga';

/**
 * Outbound clicks — ported from the .in engine's @common/events/go-redirection.js.
 *
 *   .go-redirection  -> open data-href in a new tab
 *   .go-redir-here   -> navigate this tab to data-href
 *
 * Delegated from document rather than .in's #gBody, because our layout has no
 * such wrapper. Both classes carry a real data-href written at generation time.
 */
const CTYPE_LABELS = {
  mb_h: 'Home Page Main Banner',
  tp_h: 'Home Page Top Picks',
  mb_m_h: 'Home Page Sub Banner',
  tab_b_h: 'Home Page Tab Banner',
  tab_c_h: "Today's Top Coupons & Offers",
};

function callGa(el) {
  const ctype = el.getAttribute('data-ctype') || '';
  const pos = el.getAttribute('data-pos') || '';
  const label = CTYPE_LABELS[ctype];
  if (!label) return;
  gaSC(pos ? `${label} - ${pos}` : label, el.getAttribute('title') || '');
}

export function goRedirectionInit() {
  document.addEventListener('click', (event) => {
    const newTab = event.target.closest('.go-redirection');
    if (newTab) {
      callGa(newTab);
      const url = newTab.getAttribute('data-href');
      if (url) window.open(url, '_blank', 'noopener');
      return;
    }

    const sameTab = event.target.closest('.go-redir-here');
    if (sameTab) {
      callGa(sameTab);
      const url = sameTab.getAttribute('data-href');
      if (url) window.location.href = url;
    }
  });
}
